<template>
  <v-card flat id="commemtForm">
    <v-form ref="form" v-model="form.valid">
      <v-flex xs12 class="formElementLabel">コメント</v-flex>
      <v-flex xs12>
        <v-textarea
          outline
          ref="commentArea"
          :disabled="!isLogin"
          v-model="form.content"
          :rules="[rules.max500]"
          :placeholder="`${userName}さんへコメントする`" style="padding-top:0;" rows="5"
        ></v-textarea>
      </v-flex>
      <v-flex xs12 style="margin-top:0px;">
        <v-btn v-if="isLogin" block dark color="primary" @click="sendForm">
          <div v-if="isLoading">
              <v-progress-circular
                indeterminate
                color="white"
              ></v-progress-circular>
            </div>
            <span v-else>コメントを投稿する</span>
        </v-btn>
        <div v-else>
          <router-link :to="{name: 'login'}">ログイン</router-link>
          してコメントを投稿しよう！
        </div>
      </v-flex>
    </v-form>
  </v-card>
</template>

<script>
import { db } from '@/main'
export default {
  name: 'ReviewCommentForm',
  data () {
    return {
      isLoading: false,
      form: {
        content: '',
        valid: false
      },
      rules: {
        max500: v => {
          return v.length <= 500 || '入力できるのは500文字までです。'
        }
      }
    }
  },
  props: {
    postId: String,
    userName: String
  },
  computed: {
    isLogin () {
      return this.$store.state.user.isLogin
    },
    user () {
      return this.$store.state.user
    }
  },
  created () {
  },
  methods: {
    async sendForm () {
      if (this.isLoading) return

      if (this.form.content === '') {
        let obj = {
          group: 'messageBottom',
          type: 'warning',
          title: '入力エラー',
          text: 'コメントを入力してください。'
        }
        this.$emit('onMessage', obj)
        return
      }
      this.$refs.form.validate()
      if (!this.form.valid) {
        let obj = {
          group: 'messageBottom',
          type: 'warning',
          title: '入力エラー',
          text: '各項目のエラーメッセージを確認して修正をお願いします。'
        }
        this.$emit('onMessage', obj)
        return
      }
      let sendData = this.makeFormObj()
      this.isLoading = true
      // 新規追加
      await db.collection('post').doc(this.postId).collection('comment').add(sendData)
      this.sendFin()
    },
    sendFin () {
      this.form.valid = false
      this.form.content = ''
      this.isLoading = false
      this.$store.dispatch('addPostComment', this.postId)
      let obj = {
        group: 'messageBottom',
        type: 'success',
        title: 'Thank you !!',
        text: 'コメントを投稿しました！'
      }
      this.$emit('onMessage', obj)
      this.$emit('onReviewCommentAdd')
    },
    makeFormObj () {
      let timestamp = new Date()
      let obj = {
        content: this.form.content,
        timestamp: timestamp,
        postId: this.postId,
        user: {
          uid: this.user.uid,
          displayName: this.user.displayName,
          imageurl: this.user.imageurl
        }
      }
      return obj
    },
    onFocus () {
      this.$refs.commentArea.focus()
    }
  },
  components: {
  }
}
</script>
<style scoped>
.formElementLabel {
  text-align: left;
  color:#888;
}
.formBlock {
  margin-bottom:10px;
}
.v-input__slot {
  margin-bottom:1px;
}
textarea {
  margin-top: 0;
}
</style>
